export const OIL_PRODUCT_COLORS: Record<string, string> = {
  // Gasoline (AI):
  AI76: '#1E90FF',
  AI80: '#00BFFF',
  AI80K2: '#87CEEB',
  AI80K3: '#4682B4',
  AI80K4: '#5F9EA0',
  AI80K5: '#7B68EE',
  AI91: '#2E8B57',
  ['AI91K2–K5']: '#2E8B57',
  AI92: '#32CD32',
  ['AI92K2–K5']: '#32CD32',
  AI92PRIME: '#FFD700',
  AI95: '#228B22',
  ['AI95K2–K5']: '#228B22',
  AI95PREMIUM: '#FFD700',
  AI95PRIME: '#FFDF00',
  G95: '#FF8C00',
  AI98: '#9932CC',
  AI98SUPER: '#BA55D3',
  AI98PRIME: '#DAA520',
  AI100: '#9400D3',
  G100: '#8A2BE2',

  // Diesel (DT):
  DT: '#FF4500',
  DTZ: '#FFA500',
  ['DTZK2–K5']: '#FFA500',
  DTL: '#D2691E',
  ['DTLK2–K5']: '#D2691E',
  DTA: '#A52A2A',
  DTE: '#8B4513',

  // Jet Fuel:
  TS1: '#8A2BE2',
  JETFUEL: '#9370DB',

  // Special Products:
  PTB: '#DC143C',
  HYDRAZINE: '#FF0000',
  NPD: '#FF6347',
  DISTILLYAT: '#CD5C5C',
  NEFRAS: '#B22222',

  // Unspecified:
  UNKNOWN: '#808080',
};
